import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Meta } from 'types/meta';
import { PaymentStatus } from 'types/paymentStatus';
import { TipsType } from 'types/tips';
import { Framework } from 'client/components/Framework';
import { Head } from 'common/components/Head';
import { api } from 'services/api';
import { initialMeta } from 'services/initialStates';
import { BackgroundImage } from 'styles/BackgroundImage';
import { FullScreen } from 'styles/FullScreen';

export const PaymentStatusPage: FC<{ type: TipsType }> = ({ type }) => {
  const { t } = useTranslation();
  const { hash, uuid } = useParams() as { hash: string; uuid: string };
  const [meta, setMeta] = useState<Meta>(initialMeta);
  const [status, setStatus] = useState<PaymentStatus>('pending');
  const [statusFinal, setStatusFinal] = useState<boolean>(false);

  const getStatus = () => {
    if (statusFinal) return;
    api()
      .getPaymentStatus(type, hash, uuid)
      .then(data => {
        if (data.status !== 'pending') setStatusFinal(true);
        setStatus(data.status);
      });
  };

  useEffect(() => {
    api()
      .getEmployee(type, hash)
      .then(data => {
        setMeta(data.meta);
      });

    setInterval(() => getStatus(), 3000);
  }, []);

  const renderStatus = (status: PaymentStatus): string => {
    switch (status) {
      case 'success':
        return t('paymentSuccess');
      case 'pending':
        return t('paymentPending');
      case 'failure':
        return t('paymentFailure');
      default:
        return 'Something went wrong';
    }
  };

  return (
    <FullScreen>
      <Head
        title={t('paymentStatusPage')}
        description={t('paymentStatusPage')}
      />
      <BackgroundImage source={meta.background} />
      <Framework locales={meta.locales} logo={meta.logo} color={meta.color}>
        <h1
          style={{
            marginTop: '80px',
            marginBottom: '80px',
            textAlign: 'center'
          }}
        >
          {renderStatus(status)}
        </h1>
      </Framework>
    </FullScreen>
  );
};
